document.addEventListener("turbo:load", function() {
  $('table.table-sortable').sortableTable();
});


// Die .info-popover-Elemente kommen teils aus Decorators, die auch das Backoffice verwendet.
// Darum werden data-content/data-title gelesen und nicht die data-bs-* Attribute von Bootstrap 5.
function init_popover() {
  document.querySelectorAll('.info-popover').forEach((element) => {
    bootstrap.Popover.getOrCreateInstance(element, {
      trigger: 'hover',
      content: element.dataset.content || '',
      placement: element.dataset.placement || 'bottom',
      ...(element.dataset.title && { title: element.dataset.title })
    })
  })
}

["turbo:load", "turbo:frame-load", "tooltips-initialisieren"].forEach((event) => {
  document.addEventListener(event, init_popover)
})
